export enum DragDropInsertMethod {
  insertBefore = 1,
  insertAfter = 2,
  insertInto = 3,
  insertBottomOfRootDI = 4,
  insertTopOfRootDI = 5,
  replace = 6
}
